export default __webpack_public_path__ + "static/media/stock_out.cea51bd2.png";